import { RelationshipsAndGuarantorsConstants } from './relationshipsAndGuarantors.constants'
import {
  IRelationshipsAndGuarantors,
  IRelationshipsAndGuarantorsAction,
  IRelationshipsAndGuarantorsState,
} from './relationshipsAndGuarantors.types'

export const initialRelationshipsAndGuarantors: IRelationshipsAndGuarantors = {
  ptid: null,
  relationship: null,
  nextOfKin: false,
  sameResidence: false,
  firstName: '',
  middleInitial: '',
  lastName: '',
  suffix: null,
  unknownName: false,
  dob: null,
  age: null,
  ageUnit: null,
  ssn: null,
  driversLicense: '',
  driversLicenseState: null,
  key: '',
}

export const initialRelationshipsAndGuarantorsState: IRelationshipsAndGuarantorsState = {
  relationshipsAndGuarantorsData: initialRelationshipsAndGuarantors,
  relationshipsAndGuarantorsList: [],
  selectedRelationshipsAndGuarantorsKey: null,
}

export function relationshipsAndGuarantorsReducer(
  state: IRelationshipsAndGuarantorsState = initialRelationshipsAndGuarantorsState,
  action: IRelationshipsAndGuarantorsAction
): IRelationshipsAndGuarantorsState {
  switch (action.type) {
    case RelationshipsAndGuarantorsConstants.SET_RELATIONSHIP:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          relationship: action.relationship,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_NEXT_OF_KIN:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          nextOfKin: action.nextOfKin,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_SAME_RESIDENCE:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          sameResidence: action.sameResidence,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_FIRST_NAME:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          firstName: action.firstName,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_MIDDLE_INITIAL:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          middleInitial: action.middleInitial,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_LAST_NAME:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          lastName: action.lastName,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_SUFFIX:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          suffix: action.suffix,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_UNKNOWN_NAME:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          unknownName: action.unknownName,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_DOB:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          dob: action.dob,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_AGE:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          age: action.age,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_AGE_UNIT:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          ageUnit: action.ageUnit,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_SSN:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          ssn: action.ssn,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          driversLicense: action.driversLicense,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE_STATE:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ...state.relationshipsAndGuarantorsData,
          driversLicenseState: action.driversLicenseState,
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_STATE:
      return {
        ...state,
        ...action.relationshipsAndGuarantors,
      }
    case RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_DATA:
      return {
        ...state,
        relationshipsAndGuarantorsData: action.relationshipsAndGuarantorsData,
      }
    case RelationshipsAndGuarantorsConstants.CLEAR_RELATIONSHIPS_AND_GUARANTORS_DATA:
      return {
        ...state,
        relationshipsAndGuarantorsData: {
          ptid: null,
          relationship: null,
          nextOfKin: false,
          sameResidence: false,
          firstName: '',
          middleInitial: '',
          lastName: '',
          suffix: null,
          unknownName: false,
          dob: null,
          age: null,
          ageUnit: null,
          ssn: null,
          driversLicense: '',
          driversLicenseState: null,
          key: '',
        },
      }
    case RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_LIST:
      return { ...state, relationshipsAndGuarantorsList: action.relationshipsAndGuarantorsList }
    case RelationshipsAndGuarantorsConstants.REMOVE_RELATIONSHIPS_AND_GUARANTORS:
      return { ...state, selectedRelationshipsAndGuarantorsKey: action.selectedRelationshipsAndGuarantorsKey }
    case RelationshipsAndGuarantorsConstants.RESET_RELATIONSHIPS_AND_GUARANTORS_STATE:
      return {
        relationshipsAndGuarantorsData: {
          ptid: null,
          relationship: null,
          nextOfKin: false,
          sameResidence: false,
          firstName: '',
          middleInitial: '',
          lastName: '',
          suffix: null,
          unknownName: false,
          dob: null,
          age: null,
          ageUnit: null,
          ssn: null,
          driversLicense: '',
          driversLicenseState: null,
          key: '',
        },
        relationshipsAndGuarantorsList: [],
        selectedRelationshipsAndGuarantorsKey: null,
      }
    default:
      return state
  }
}
